<template>
  <div class="row">
    <!-- <div class="col-lg">
      <h2>Add User</h2>
    </div> -->
    <div class="col-md-12">
      <div class="col-lg-12 text-center">
        <h2>Please fill in the form below</h2>
      </div>
      <card class="stacked-form">
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-4 ml-auto mr-auto">
              <h3 style="border-bottom: solid red">Schedule Editor</h3>
              <base-input label="Employee ID" placeholder="Employee ID">
                <el-autocomplete
                  class="el-input"
                  v-model="EmployeeID"
                  :fetch-suggestions="querySearch"
                  Placeholder="Please enter the content"
                  :trigger-on-focus="false"
                  >
                </el-autocomplete>
                </base-input>
                <base-input label="Shift Code" placeholder="Shift Code ID">
                <el-select
                    class="select-primary"
                    size="large"
                    placeholder="Single Select"
                    v-model="ShiftCodeID"
                >
                    <el-option
                    v-for="option in shiftCode"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                    >
                    </el-option>
                </el-select>
                </base-input>
                <base-input label="Begin Date" v-model="BeginDate">
                <el-date-picker 
                    v-model="BeginDate"
                    type="date"
                    placeholder="Begin Date"
                ></el-date-picker>
                </base-input>
                <base-input label="End Date" v-model="EndDate">
                <el-date-picker 
                    v-model="EndDate"
                    type="date"
                    placeholder="End Date"
                ></el-date-picker>
              </base-input>
              <base-input label="Day Off" v-model="dayoff">
                <el-select
                      class="select-success"
                      size="large"
                      placeholder="Multiple Select"
                      v-model="dayoff"
                      multiple
                      filterable
                  >
                    <el-option
                    v-for="option in off"
                    class="select-success"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                    >
                    </el-option>
                </el-select>
              </base-input>
            </div>
          </div>
        </form>
      </card>
      <div class="col-lg-12 text-center">
        <el-link href="./img/csv/ScheduleRegistration.csv" class="mt-3" type="primary">Download CSV template</el-link>
        &nbsp;
        <base-button 
          @click="modalsCSV = true"
          class="mt-3"
          native-type="submit"
          type="green"
          simple
        >Import with CSV</base-button>&nbsp;
        <base-button
          class="mt-3"
          native-type="submit"
          type="primary"
          @click="registerSchedule()"
          >Submit</base-button
        >
      </div>
      <!-- modal -->
      <modal :show.sync="modalsCSV" footer-classes="justify-content-center" type="notice">
        <h3 slot="header" class="modal-title">Import CSV Form</h3>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12 text-center">
              <label id="fileName">{{ fileName }}</label>
              <span class="btn btn-info btn-file">
                <span class="fileinput-new">Choose File</span>
                <input
                  accept=".csv"
                  type="file"
                  class="valid"
                  :multiple="false"
                  @change="readFile"
                />
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-center spinner" v-if="load">
            <circle-8></circle-8>
          </div>
        </div>
        <template slot="footer">
          <base-button
            @click="send()"
            :disabled="disabledsend"
            class="mt-3"
            native-type="submit"
            type="success"
          >Submit</base-button>&nbsp;&nbsp;&nbsp;
          <base-button class="mt-3" type="danger" @click.native="modalsCSV = false">Cancel</base-button>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import { BaseCheckbox, BaseRadio } from "src/components/index";
import { Select, Option, TimeSelect, DatePicker, Autocomplete, Link } from "element-ui";
import { touches } from "d3";
import swal from "sweetalert2";
import moment from "moment";
import { Modal } from "src/components/index";
import { Circle8 } from "vue-loading-spinner";

export default {
  components: {
    Modal,
    BaseCheckbox,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseRadio,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Autocomplete.name]: Autocomplete,
    Circle8,
    [Link.name]: Link
  },
  data() {
    return {
      load: false,
      select: [],
      shiftCode: [],
      EmployeeID: "",
      ShiftCodeID: "",
      BeginDate: "",
      EndDate: "",
      selects: {

      },
      dayoff: [],
      off: [
        {
          label: "Monday",
          value: "Monday"
        },
        {
          label: "Tuesday",
          value: "Tuesday"
        },
        {
          label: "Wednesday",
          value: "Wednesday"
        },
        {
          label: "Thursday",
          value: "Thursday"
        },
        {
          label: "Friday",
          value: "Friday"
        },
        {
          label: "Saturday",
          value: "Saturday"
        },
        {
          label: "Sunday",
          value: "Sunday"
        }
      ],
      modalsCSV: false,
      disabled: true,
      disabledsend: true,
      fileName: "",
      employee: [],
      shift: [],
      datacsv: []
    };
  },
  mounted() {

  },
  created(){
    this.getEmployeeID();    
    this.getShiftCode();
  },
  methods: {
    readFile(ev){
      this.dataCSV = [];
      let temp = []
      const file = ev.target.files[0];
      const reader = new FileReader();
      reader.readAsText(file);
      this.fileName = file.name
      
      reader.onload = e => {
        let header;
        let lines = [];
        let csv = e.target.result;
        let allTextLines = csv.split(/\r\n|\n/);
        for(var i=0; i<allTextLines.length; i++){
          if(i == 0){
            header = allTextLines[i].split(",");
          } else {
            lines.push(allTextLines[i].split(","));
          }
        }
        
        lines.pop();
        console.log("header", header)
        let keysubmit = 0
        // check header name 
        if( header[0] !== "EmployeeID" || header[1] !== "Shift Code ID" || header[2] !== "Begin Date" || header[3] !== "End Date" || header[4] !== "Off Day" ){
          // let img = "@/assets/img/schedule-csv.PNG" 
          swal({
            title: "Header Error!",
            html: '<b>Make sure you follow the predefined header as below:</b><img width="100%" height="100%" src="img/schedule-csv.PNG">',
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false
          })
        } else {
          console.log("lines", lines)
          lines.forEach(line => {
            console.log(line[1])
            

            // find  status id
            if(line[0] == "" || line[1] == "" || line[2] == "" || line[3] == "" || line[4] == ""){
              swal({
                title: "Data Error!",
                text: "All data must be filled!",
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false
              });
            } else {
              // check empid 
              let empstatus = 1
              for(var i=0; i<this.employee.length; i++){
                if(line[0] == this.employee[i]){
                  this.disabled = true
                  empstatus = 0
                  break;
                }
              }

              if(empstatus == 1){
                swal({
                  title: "Data Error!",
                  text: "Employee ID " + line[0] + " does not exist!",
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false
                });
              }

              // check shift code
              let shiftstatus = 1
              console.log(this.shift)
              for(var i=0; i<this.shift.length; i++){
                if(line[1] == this.shift[i]){
                  this.disabled = true
                  shiftstatus = 0
                  
                }
              }

              if(shiftstatus == 1){
                swal({
                  title: "Data Error!",
                  text: "Shift code " + line[1] + " for employee ID " + line[0] + " does not exist!",
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false
                });
              }

              // check off day
              console.log(line[4])
              let a = line[4].split(' ')
              console.log(a)
              
              for(var i=0; i<a.length; i++){
                if (a[i] == "Monday" || a[i] == "Tuesday" || a[i] == "Wednesday" || a[i] == "Thursday" || a[i] == "Friday" || a[i] == "Saturday" || a[i] == "Sunday" ){

                } else {
                  swal({
                    title: "Typing Error!",
                    text: "Typing error " + a[i] + " for employee ID " + line[0],
                    type: "warning",
                    confirmButtonClass: "btn btn-success btn-fill",
                    confirmButtonText: "Okay",
                    buttonsStyling: false
                  });
                }
              }

              // check date
              let startstatus = 0
              let startdate = moment(line[2],"DD/MM/YYYY").format("YYYY-MM-DD")
              console.log(startdate)
              if(startdate == "Invalid date"){
                startstatus = 1
                swal({
                  title: "Data Error!",
                  text: "Invalid Begin Date " + line[2] + " for employee ID " + line[0],
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false
                });
              }

              // check date
              let endstatus = 0
              let enddate = moment(line[3],"DD/MM/YYYY").format("YYYY-MM-DD")
              console.log(enddate)
              if(enddate == "Invalid date"){
                endstatus = 1
                swal({
                  title: "Data Error!",
                  text: "Invalid End Date " + line[3] + " for employee ID " + line[0],
                  type: "warning",
                  confirmButtonClass: "btn btn-success btn-fill",
                  confirmButtonText: "Okay",
                  buttonsStyling: false
                });
              }
              
              if( empstatus == 0 && shiftstatus == 0 && startstatus == 0 && endstatus == 0){
                keysubmit = 1
                let payload = {
                  EmpID: line[0],
                  ShiftCodeID: line[1],
                  BeginDate: moment(line[2],"DD/MM/YYYY").format("YYYY-MM-DD"),
                  EndDate: moment(line[3], "DD/MM/YYYY").format("YYYY-MM-DD"),
                  OffDay: a
                }
                console.log(payload)
                temp.push(payload)
              }
              
            }
          })
          if(keysubmit == 1){
            this.datacsv = temp
            console.log(this.datacsv)
            this.disabledsend = false
            // this.send(temp)
          }
        }
        
      }
    },
    querySearch(queryString, cb) {
        var links = this.select;
        console.log(links)
        var results = queryString ? links.filter(this.createFilter(queryString)) : links;
        // call callback function to return suggestions
        cb(results);
    },
    createFilter(queryString) {
      console.log(queryString)
        return (link) => {
          return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
    },
    handleSelect(item) {
      console.log(item.value)
      // checking id not exist
      for(var i=0; i<this.select.length; i++){
      if(typeof this.select[i] === item.value) {
        // does not exist
        console.log("does not exist")
      }
      else {
        // does exist
        console.log("does exist")
      }
      }
      console.log(this.event.programCode)
      this.event.programCode = item.value
    },
    getEmployeeID(){
      this.select = []
      this.$http.get(":9995/api/v1/manage/employee")
        .then(res=> {
          if(!res.error){
            let data = res.message
            console.log(data)
            let e = []
            for(var i=0; i<data.length; i++){
              let obj = {
                data: data[i].EmpID,
                value: data[i].EmpID
              }
              this.select.push(obj)
              e.push(data[i].EmpID)
            }
            console.log(this.select)

            let temp = []
            for(var i=0; i<e.length; i++){
              if(temp.indexOf(e[i]) === -1){
                temp.push(e[i])
              }
            }
            console.log(temp)
            this.employee = temp

          }
        })
    },
    getShiftCode(){
      this.shiftCode = []
      this.$http.get(":9995/api/v1/manage/shift")
        .then(res =>{
          if(!res.error){
            let data = res.message
            console.log(data)

            for(var i=0; i<data.length; i++){
              let obj = {
                data: data[i].ShiftCodeID,
                value: data[i].ShiftCodeID
              }
              this.shift.push(data[i].ShiftCodeID)
              this.shiftCode.push(obj)
            }
          }
        })  
    },
    registerSchedule(){
      this.datacsv = []
      let arr = []
      console.log(this.EmployeeID)
      console.log(this.ShiftCodeID)
      console.log(this.BeginDate)
      console.log(this.EndDate)
      console.log(this.dayoff)

      let payload = {
        EmpID: this.EmployeeID,
        ShiftCodeID: this.ShiftCodeID,
        BeginDate: moment(this.BeginDate).format("YYYY-MM-DD"),
        EndDate: moment(this.EndDate).format("YYYY-MM-DD"),
        OffDay: this.dayoff
      }
      this.datacsv.push(payload)
      console.log(payload)
      this.send()
    },
    send(){
      this.load = true
      this.disabledsend = true
      console.log(this.datacsv)
      // send 
      this.$http.post(":9995/api/v1/manage/schedule" , this.datacsv)
        .then(res => {
          if(!res.error){
            let data = res.message
            swal({
              title: "Successful!",
              text: res.message,
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false
            });
            this.modals2 = false
            this.EmployeeID = ""
            this.ShiftCodeID = ""
            this.BeginDate = ""
            this.EndDate = ""
            this.datacsv = []
            
            this.$router.push({ path: `/Attendance/ScheduleEdit` });
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false
            });
            
          }
          this.load = false
          this.disabledsend = false
        })  
    }
  }
};
</script>
<style lang="scss">
.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}
</style>
